import { type ImgHTMLAttributes, type ReactNode, type SyntheticEvent, useState } from 'react'

import { type IMAGE_TYPES, transformImageUrl } from '@components/productImage/data'
import { cx } from '@utils/cx'

interface TransformableImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  type: IMAGE_TYPES
  loadingPlaceholder?: ReactNode
}

function TransformableImage({ src, type, loadingPlaceholder, onLoad, ...restProps }: TransformableImageProps) {
  const [isLoading, setIsLoading] = useState(true)

  const handleLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    setIsLoading(false)
    onLoad?.(e)
  }

  const transformedSrc = transformImageUrl(src, type)

  return (
    <>
      {isLoading && loadingPlaceholder}
      <img
        src={transformedSrc}
        onLoad={handleLoad}
        className={cx(isLoading && loadingPlaceholder ? 'hidden' : '', restProps.className)}
        {...restProps}
      />
    </>
  )
}

export default TransformableImage